
















import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { ProductTypes } from "@/data/enums/products";
import { ListDisplayMode } from "@/data/constants";
import { UserMetaKeys } from "@/data/enums/users";
import { mapState } from "vuex";

@Component({
  components: {
    "multilevel-categories-with-products": () =>
      import(
        "@/components/app/admin/catalogue/products/multilevelCategories/multilevelCategoriesWithProducts.vue"
      ),
    "catalogue-product-search": () =>
      import("@/components/app/admin/catalogue/catalogueProductSearch.vue")
  },
  computed: {
    ...mapState({
      showTreeView: (state, getters) => {
        const m = getters[`user/meta`](UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE);
        if ([ListDisplayMode.GRID].includes(m)) return false;
        return true;
      }
    })
  }
})
export default class BrandSettingsProductsView extends Vue {
  @Prop({
    default: () => [ProductTypes.SINGLE_PRODUCT, ProductTypes.PRODUCT_BUNDLE]
  })
  public productTypes!: ProductTypes[];

  public tableId = "PS1";
  public treeKey = "TV";
  public showTreeView!: boolean;

  public created() {
    this.$bus.$on("refreshProductSearchTree", () => {
      this.refreshTreeView();
    });
  }

  public get isOption() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION);
  }
  public get isAttribute() {
    return this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE);
  }

  public get productType() {
    return this.$t(
      this.isOption
        ? "_.product_option"
        : this.isAttribute
        ? "_.product_attribute"
        : "_.product"
    )
      .toString()
      .toLowerCase();
  }

  public get i18n() {
    return {
      cta: this.$t("_action.add_object", { object: this.productType }),
      title: this.$t("_.add_your_first_object", {
        object: this.productType
      }),
      description: this.$t("_sentence.catalogue_products_onboarding_desc")
    };
  }

  public refreshTreeView() {
    this.treeKey = `TV_${this.$uuid()}`;
  }

  public beforeDestroy() {
    this.$bus.$off("refreshProductSearchTree");
  }
}
